
try {
  if (!String.prototype.toLocaleString) {
    String.prototype.toLocaleString = function() { return this.toString(); };
  }
} catch (e) {
  console.error(e);
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
